import { Buffer } from "buffer";
import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { Redirect } from "react-router-dom";

export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "") {
      errorState[item] = "Vui lòng nhập thông tin";
    }
  });
  return errorState;
};

//Function that returns the first or first two letters from a name
export const findUpper = (string) => {
  let extractedString = [];

  for (var i = 0; i < string.length; i++) {
    if (
      string.charAt(i) === string.charAt(i).toUpperCase() &&
      string.charAt(i) !== " "
    ) {
      extractedString.push(string.charAt(i));
    }
  }
  if (extractedString.length > 1) {
    return extractedString[0] + extractedString[1];
  } else {
    return extractedString[0];
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to set deadline for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  reverse ? (date = m + "-" + d + "-" + y) : (date = y + "-" + d + "-" + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);
  return date;
};

export const DEFAULT_DELIVERY_PROVIDER_ID = 'NCC_VCPHUONGNAM';

export const weekDayNames = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
//Month Names
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//todays Date
export const todaysDate = new Date();
export const formatDateYMD = "YYYY-MM-DD";
// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

//shortens a long string
export const truncate = (str, n) => {
  return str.length > n
    ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n)
    : str;
};

export const RedirectAs404 = ({ location }) => (
  <Redirect to={Object.assign({}, location, { state: { is404: true } })} />
);

export const readPicAsDataURL = (file) =>
  new Promise((resolve) => {
    let reader = new FileReader();
    reader.onloadend = () => {
      const image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({
          value: reader.result,
          width: this.width,
          height: this.height,
        });
      };
    };
    reader.readAsDataURL(file);
  });

export const BILL_STATUS = {
  INIT: "Mới",
  APPROVED: "Đã duyệt",
};

export const DRAFF_BILL_FILTER_DUPLIDATE = {
  BOTH: "Tất cả",
  EXCLUDE_EXISTED_BILL: "Không hiện đơn đã tồn tại",
};

export const BILL_RED_FLAG = {
  1: "Cảnh báo",
  0: "Hợp lệ",
};

export const COMPANY_CODE = {
  TL: "TL",
  CT: "CT",
  PN: "PN",
}
export const COMPANY = {
  [COMPANY_CODE.TL]: "Tấn Lộc",
  [COMPANY_CODE.CT]: "Cường Thịnh",
};

export const COMPANY_EXTENDED = {
  ...COMPANY,
  [COMPANY_CODE.PN]: "Phương Nam",

};
export const USER_ROLES = {
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  SHIFT_LEADER: "SHIFT_LEADER",
  BILL_APPROVER: "BILL_APPROVER",
  ENTRY_STAFF: "ENTRY_STAFF",
  DRIVER: "DRIVER",
  STAFF: "STAFF",
  OFFICE_WORKER: "OFFICE_WORKER",
};

export const USER_ROLES_NAME = {
  ADMIN: "Giám đốc",
  MANAGER: "Quản lý",
  SHIFT_LEADER: "Trưởng ca",
  BILL_APPROVER: "Người duyệt đơn",
  ENTRY_STAFF: "Người nhập nội dung",
  DRIVER: "Lái xe",
  STAFF: "Công nhân",
  OFFICE_WORKER: "NVVP",
  SYSTEM_APP_SCALE: "Phần mềm cân",
};

export const pageStyleBill = "@page { size: A4 landscape; background: white }";
export const pageStylePackage =
  "@page { size: A6 landscape; background: white }";

export const EMPLOYEE_STATUS = {
  OFFICIAL: "Chính thức",
  PROBATION: "Thử việc",
  UNEMPLOYMENT_BENEFITS: "Hưởng trợ cấp thất nghiệp",
  FREELANCE: "Thuê (Không đóng bảo hiểm)",
};

export const TIME_KEEPING_TYPE = {
  WORK: "Chấm công",
  OFF_WORK: "Nghỉ",
};

export const OFF_SHIFT_TYPE = {
  4: "Nửa buổi",
  8: "Cả buổi",
};

export const MONEY_TYPE = {
  IN: "Thu",
  OUT: "Chi",
};

export const CATEGORY_TYPE = {
  IN: "Thu",
  OUT: "Chi",
};

export const CUSTOMER_TYPE = {
  IN: "Nhà cung cấp",
  OUT: "Khách hàng",
};

export const CUSTOMER_MONEY_FLOW_TYPE = {
  IN: "Thu",
  OUT: "Chi",
};

export const LOCATION = {
  INTERNAL: "Trong nước",
  EXTERNAL: "Xuất khẩu",
};


export const DEFAULT_CUSTOMER_BANK_ACCOUNT = {
  name: '',
  bankNumber: '',
  bankCode: '',
  branch: '',
  note: '',
}

export const DEFAULT_CUSTOMER_METADATA = {
  phoneNumber: '',
  address: '',
  taxAddress: '',
  taxCode: '',
  taxCompanyName: '',

  bankAccounts: [{
    ...DEFAULT_CUSTOMER_BANK_ACCOUNT,
  }],
  note: '',
}
export const CUSTOMER_LOCATION = {
  INTERNAL: 'INTERNAL',
  EXTERNAL: 'EXTERNAL',
};

// customerType: OUT = khách hàng, IN = nhà cung cấp
export const getCustomerLocationOptions = (customerType) => [
  { label: 'Nội địa', value: CUSTOMER_LOCATION.INTERNAL },
  { label: customerType === 'OUT' ? 'Xuất khẩu' : 'Nhập khẩu', value: CUSTOMER_LOCATION.EXTERNAL },
];

export const DEFAULT_CUSTOMER = {
  id: "",
  name: "",
  type: "IN",
  location: CUSTOMER_LOCATION.INTERNAL,
  isDeliveryProvider: false,
  licensePlates: [],
  metadata: {
    ...DEFAULT_CUSTOMER_METADATA,
  },
};

// Chuẩn hoá biển số xe: chỉ giữ chữ, số, dấu ( ), viết hoa. VD: "51a - 235235" => "51A235235"
export const formatLicensePlate = (value) => (value || '').toString().toUpperCase().replace(/[^A-Z0-9()]/g, '');

export const DEFAULT_TRANSFER_BETWEEN_ACCOUNT = {
  date: null,
  amount: null,
  fromBankAccountId: null,
  toBankAccountId: null,
  content: null
};



export const defaultPNCustomer = () => ({
  id: "",
  name: "",
  type: "IN",
  location: 'INTERNAL',
  isNeedClaimCustomer: false,
  metadata: {
    taxCode: "",
    taxCompanyName: "",
    phoneNumber: "",
    taxAddress: "",
    vatEmail: "",
    address: "",
    note: "",
  },
});

export const PN_HARD_CATEGORY_ID = {
  personalIncomeTax: -1,
  oilOutOutside: -2,
  paySalary: -3,
  insuranceFee: -4,
  mortgagePayFee: -6,
  exchangeBankAccountIn: -7,
  exchangeBankAccountOut: -8,
  investInPurchasingMaterialsCT: -9,
  investInPurchasingMaterialsTL: -10,
  repareInPurchasingMaterialsCT: -11,
  repareInPurchasingMaterialsTL: -12,
  outCustomerOutMoney: -13,
  outCustomerInMoney: -14,
  inCustomerInMoney: -15,
  inCustomerOutMoney: -16,
  inDriverDownContainer: -20,
  inDriverUpContainer: -19,
  inDriverFosteringUpDownContainer: -18,
  serviceRepairInventoryTL: -21,
  serviceRepairInventoryCT: -22,
  feeCO: -23,
  feeInfrastructure: -24,
  fixDiffAmountIn: -25,
  fixDiffAmountOut: -26,
  containerDownFee: -27,
  mortgagePayInteresFee: -28,
  ePassInFee: -29,
  repairCompany: -30,
};

export const renderLabelIngredientPriceHistoryOption = (item) => (
  <>
    {moment(item?.createdAt).format("DD-MM-YYYY")}(
    <NumericFormat
      value={(item?.quotaWeight || 0) - (item?.currentWeight || 0)}
      displayType={"text"}
      decimalScale={2}
      thousandSeparator={","}
      thousandsGroupStyle="thousand"
      suffix=" kg"
    /> / <NumericFormat
      value={item?.quotaWeight || 0}
      displayType={"text"}
      decimalScale={2}
      thousandSeparator={","}
      thousandsGroupStyle="thousand"
      suffix=" kg"
    />
    ) {item?.targetBy === INGREDIENT_PRICE_HISTORY_TARGET_BY.TRUCK && <>(<NumericFormat
      value={(item?.quotaNumOfTruck || 0) - (item?.numOfTruck || 0)}
      displayType={"text"}
      decimalScale={2}
      thousandSeparator={","}
      thousandsGroupStyle="thousand"
      suffix=" xe"
    />/<NumericFormat
        value={item?.quotaNumOfTruck || 0}
        displayType={"text"}
        decimalScale={2}
        thousandSeparator={","}
        thousandsGroupStyle="thousand"
        suffix=" xe"
      />)</>}
    (<NumericFormat
      value={item?.amount || 0}
      displayType={"text"}
      decimalScale={2}
      thousandSeparator={","}
      thousandsGroupStyle="thousand"
      suffix=" đ/kg"
    />)
  </>
);

export const BILL_TYPE = {
  IN: "Nhập",
  OUT: "Xuất",
  SERVICE: "Dịch vụ",
};

export const INGREDIENT_PRICE_HISTORY_STATUS = {
  INIT: "Khởi tạo",
  APPROVED: "Đã duyệt",
  REJECTED: "Từ chối",
  DONE: "Hoàn thành",
};

export const EMPLOYEE_PAY_IN_OUT_CATEGORY = {
  OTHER_FEE: "Chi phí khác",
  BONUS_OUTSIDE: "Thưởng ngoài",
  PIT_FEE: "Thuế TNCN",
  INSURANCE_LEAVE_FEE: "Trừ bảo hiểm nghỉ phép",
};

export const PIECE_WAGE_PRICE_TYPE = {
  STATIC: "Cố định",
  PRICE_PER_UNIT: "Theo khối lượng",
  OPTIONS: "Lựa chọn",
};

export const INVENTORY_TYPE = {
  IN: "Nhập",
  OUT: "Xuất",
};

export const MORTGAGE_STATUS = {
  INIT: "KHỞI TẠO",
  FINISHED: "KẾT THÚC",
};

export const SUMARY_STATEMENT_TYPE = {
  BANK_ACCOUNT: "Quỹ tài khoản",
  BANK_ACCOUNT_USD: "Quỹ tài khoản USD",
  CUSTOMER: "Khách hàng",
  INGREDIENT_LAST_WEIGHT: "Khối lượng nguyên liệu",
  LAST_AMOUNT: "Tiền đầu kì",
  MORTGAGE_CONTRACT: "Khoản vay",
  TAX: "Thuế",
  INVENTORY_MATERIAL: "Tồn kho vật tư",
  INVENTORY_QUOTATION_VALUE: "Giá trị kho cuối kì",
  // Kho gia công: tồn dầu tinh của từng KH nhận gia công, key = `${customerId}|DTP`
  PROCESSING_INVENTORY: "Tồn kho gia công (Dầu tinh)",
};

// Key đầu kỳ kho gia công, khớp buildProcessingInventoryKey của BE
export const PROCESSING_INVENTORY_INGREDIENT_ID = "DTP";
export const buildProcessingInventoryKey = (customerId) => `${customerId}|${PROCESSING_INVENTORY_INGREDIENT_ID}`;

export const SUMMARY_STATEMENT_TAX_DETAIL_KEY = {
  SUMMARY: "Đầu kỳ tổng hợp",
  SUMMARY_DETAIL_EXTERNAL: "Đầu kỳ xuất khẩu",
  SUMMARY_DETAIL_INTERNAL: "Đầu kỳ nội địa",
};

export const PN_CUSTOMER_TYPE = {
  IN: "Nhà cung cấp",
  OUT: "Khách hàng",
};

export const PN_DEFAULT_CUSTOMER = {
  id: "",
  name: "",
  type: "IN",
};

export const PN_SUMARY_STATEMENT_TYPE = {
  BANK_ACCOUNT: "Quỹ tài khoản",
  BANK_ACCOUNT_USD: "Quỹ tài khoản USD",
  CUSTOMER: "Khách hàng/Nhà cung cấp",
  DRIVER_COST_ADVANCE: "Chi phí & ứng tài xế",

  PRICE_OIL: "Giá dầu",
  PRICE_PETROLEUM: "Giá nhớt máy",
  PRICE_HYDRAULIC_PETROLEUM: "Giá nhớt thuỷ lực",
  PRICE_GAS: "Giá khí thải",

  QUANTITY_OIL: "Số lượng dầu",
  QUANTITY_PETROLEUM: "Số lượng nhớt máy",
  QUANTITY_HYDRAULIC_PETROLEUM: "Số lượng nhớt thuỷ lực",
  QUANTITY_GAS: "Số lượng khí thải",
};

export const INVENTORY_FUEL_CATEGORY = {
  OIL: "Dầu",
  PETROLEUM: "Nhớt máy",
  HYDRAULIC_PETROLEUM: "Nhớt thuỷ lực",
  GAS: "Khí thải",
};

export const MATERIAL_CATEGORY_GROUP = {
  INVEST_MATERIAL: "Vật tư đầu tư",
  FIX_MATERIAL: "Vật tư sửa chữa",
  FIX_FACTORY: "Dịch vụ sửa chữa xưởng",
};

export const SHIFT = {
  MORNING: "Ca 1",
  AFTERNOON: "Ca 2",
  NIGHT: "Ca 3",
};

export const ACTION_SCAN = {
  TIME_KEEPING: "TIME_KEEPING",
  OIL_OUT_INSIDE_TRANSACTION: "OIL_OUT_INSIDE_TRANSACTION",
  PIECE_WAGE: "PIECE_WAGE",
};

export const TIME_KEEPING_IS_LOCKED_TYPE = {
  false: "Chưa khóa",
  true: "Đã khóa",
};

export const USER_ACTIVE_TYPE = {
  false: "Ngưng hoạt động",
  true: "Đang hoạt động",
};

export const TRUCK_TYPE = {
  TRUCK: "TRUCK",
  CRANE: "CRANE",
};

export const TRUCK_TYPE_NAME = {
  TRUCK: "Xe chở hàng",
  CRANE: "Xe cẩu",
};

export const TAX_KEY = {
  LAST_LESS_TAX: "LAST_LESS_TAX",
  PURCHASE_VALUE: "PURCHASE_VALUE",
  INPUT_VAT: "INPUT_VAT",
  SELL_OUT_0: "SELL_OUT_0",
  SELL_OUT_NON_FILING: "SELL_OUT_NON_FILING",
  SELL_OUT_10: "SELL_OUT_10",
  SELL_OUT_8: "SELL_OUT_8",
  SELL_OUT_TOTAL: "SELL_OUT_TOTAL",
  OUTPUT_VAT: "OUTPUT_VAT",
  DEDUCTIBLE_TAX: "DEDUCTIBLE_TAX",
  REFUND: "REFUND",
  SUMMARY: "SUMMARY",
};

export const TAX_KEY_NAME = {
  LAST_LESS_TAX: "ĐẦU KỲ",
  PURCHASE_VALUE: "GIÁ TRỊ MUA VÀO",
  INPUT_VAT: "THUẾ GTGT ĐẦU VÀO",
  SELL_OUT_0: "BÁN RA 0%",
  SELL_OUT_NON_FILING: "BÁN RA KKKNT",
  SELL_OUT_10: "BÁN RA 10%",
  SELL_OUT_8: "BÁN RA 8%",
  SELL_OUT_TOTAL: "TỔNG DOANH THU BÁN RA",
  OUTPUT_VAT: "THUẾ GTGT ĐẦU RA",
  DEDUCTIBLE_TAX: "THUẾ CÒN KHẤU TRỪ",
  REFUND: "ĐỀ NGHỊ HOÀN",
  SUMMARY: "CÒN LẠI",
};

export const REQUEST_UPDATE_STATUS = {
  REQUESTING: "REQUESTING",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  CANCELLED: "CANCELLED",
};

export const TAX_DETAIL_KEY = {
  LAST_LESS_TAX: "LAST_LESS_TAX",
  SELL_OUT: "SELL_OUT",
  PERCENT_SELL_OUT: "PERCENT_SELL_OUT",
  DEDUCTIBLE_TAX: "DEDUCTIBLE_TAX",
  ADJUST_INCREASE: "ADJUST_INCREASE",
  ADJUST_DECREASE: "ADJUST_DECREASE",
  OUTPUT_VAT: "OUTPUT_VAT",
  INTERNAL_VAT: "INTERNAL_VAT",
  PERCENT_10_SELL_OUT_EXTERNAL: "PERCENT_10_SELL_OUT_EXTERNAL",
  MINUS_INTERNAL_VAT: "MINUS_INTERNAL_VAT",
  LESS_VAT: "LESS_VAT",
  REFUND: "REFUND",
  SUMMARY: "SUMMARY",
};

export const TAX_DETAIL_KEY_NAME = {
  LAST_LESS_TAX: "ĐẦU KỲ",
  SELL_OUT: "DOANH THU",
  PERCENT_SELL_OUT: "TỈ LỆ DT",
  DEDUCTIBLE_TAX: "VAT ĐƯỢC KHẤU TRỪ",
  ADJUST_INCREASE: "ĐIỀU CHỈNH TĂNG",
  ADJUST_DECREASE: "ĐIỀU CHỈNH GIẢM",
  OUTPUT_VAT: "THUẾ GTGT ĐẦU RA",
  INTERNAL_VAT: "VAT PHẢI NỘP NỘI ĐỊA",
  PERCENT_10_SELL_OUT_EXTERNAL: "10% DT XUẤT KHẨU",
  MINUS_INTERNAL_VAT: "BÙ TRỪ VAT PHẢI NỘP NỘI ĐIA",
  LESS_VAT: "VAT CHƯA KHẤU TRỪ HẾT",
  REFUND: "ĐỀ NGHỊ HOÀN",
  SUMMARY: "CÒN LẠI",
};

export const PN_CATEGORY_GROUP = {
  DRIVER: "Tài xế",
  COMPANY_PAY_FOR_DELIVERY: "NCC cho vận chuyển",
  COMPANY_FOR_DRIVER: "Công ty trả cho tài xế",
  BANK_ACCOUNT: "Thu chi công ty",
  CUSTOMER: "KH/NCC",
  MORTGAGE_CONTRACT: "Khoản vay",
};

export const getPNDefaultTransaction = () => ({
  date: moment().format("YYYY-MM-DD"),
  type: "IN",

  amount: 0,
  exchangeRate: null,
  amountUSD: null,
  currency: "VND",

  categoryId: null,
  content: "",
  bankAccountId: null,
  customerId: null,
  userId: null,

  contractId: null,
  exchangeInterestRate: null,
  interest: null,
  interestUSD: null,
  fund: null,
  fundUSD: null,
});

export const getDefaultTransactionHistory = (defaultValue) => ({
  id: null,
  date: moment().format(formatDateYMD),
  content: "",
  categoryId: "",
  bankAccountId: "",
  receiver: "",
  address: "",
  amount: 0,

  contractId: "",
  fund: 0,
  fundUSD: 0,
  exchangeInterestRate: 0,
  interest: 0,
  interestUSD: 0,

  exchangeRate: "",
  amountUSD: "",
  currency: "VND",
  ...(defaultValue || {})
});

export const getDefaultBill = () => ({
  id: null,
  warehouseId: 'TL',
  customerId: "",
  customerName: "",
  truckId: "",
  type: "IN",
  status: "INIT",
  departureTruckWeight: 0,
  departureMerchandiseWeight: 0,
  departureTotalWeight: 0,
  destinationTruckWeight: 0,
  destinationMerchandiseWeight: 0,
  destinationTotalWeight: 0,
  ingredientId: "",
  unitPrice: 0,
  deliveryFeeByWeight: 0,
  deliveryFeeExternal: 0,
  billPictures: [],
  finalMerchandiseWeightCol: "departure",
  finalDeliveryWeightCol: "destination",
  location: "INTERNAL",
  note: "",
  pack: null,
  createdAt: moment().toDate(),
  currency: "VND",
  exchangeRate: "",
  reason: "",
  contractId: null,
  deliveryProviderId: DEFAULT_DELIVERY_PROVIDER_ID,
  billExternalContractId: 0,
  numOfContainer: 1,
  commissions: [],
});


export const getDefaultPnTransportDriverBonus = () => ({
  status: 'INIT',
  driverId: null,
  subDriverId: null,
  driverBonus: 0,
  subDriverBonus: 0,
  deliveryFeeByWeight: 0,
  deliveryFeeExternal: 0,
  location: 'INTERNAL'
})

export const getDefaultCustomerMoneyFlow = (defaultValue) => ({
  id: null,
  customerId: "",
  amount: "",
  receiver: "",
  bankAccountId: "",
  content: "",
  note: "",
  date: moment().format(formatDateYMD),
  currency: "VND",
  amountUSD: "",
  exchangeRate: "",
  ...(defaultValue || {})
});
export const FILTER_TRANSACTION_HISTORY_GROUP = {
  CUSTOMER: "Khách hàng",
  TRANSACTION: "Thu chi",
};

export const renderPageStyle = (data) => {
  const {
    hiddenActionCol = false,
    fontSize = 10,
    orientation = "landscape",
    scale = 100,
    margin = 5
  } = data || {};
  return `
  @media print {
    body {
      zoom: ${scale}%;
    }
    h5 {
      margin-top: 20px;
    }
    @page {
      size: A4 ${orientation};
      margin: ${margin}px;
    }

    td, th {
      color: black;
      padding: 5px !important;
      font-size: ${fontSize}px;
      span {
        padding: 0px !important;
        color: black;
        font-size: ${fontSize}px;
      }
    }
    ${hiddenActionCol
      ? `td:last-child, th:last-child, td.action-col, th.action-col { display: none; }`
      : ""
    }

  }
`;
};

export const roleCanConfirmAssignReview = [USER_ROLES.MANAGER];
export const checkRoleCanConfirmAssignReview = (role) =>
  roleCanConfirmAssignReview.includes(role);
export const DISPLAY_DATE_FORMAT = "DD/MM/YYYY";

export const getDefaultEmployeeDayOff = () => ({
  monthYear: moment().format("YYYY-MM"),
  userId: null,
  dayOffCount: null,
});

export const getDefaultEmployeeLeave = () => ({
  monthYear: moment().format("YYYY-MM"),
  userId: null,
  leaveDay: 1,
  leaveType: "UNPAID_LEAVE",
});

export const EXCHANGE_INTERNAL_INVENTORY_OPTIONS = [
  {
    label: "Tất cả",
    value: undefined,
  },
  {
    label: "Chỉ chuyển kho nội bộ",
    value: 1,
  },
  {
    label: "Loại trừ chuyển kho nội bộ",
    value: 0,
  },
];

export const EMPLOYEE_UNIT = {
  DIRECTOR: 'Giám đốc',
  CHIEF_ACCOUNTANT: 'Kế toán trưởng',
  NVVP: "NVVP",
  STAFF_SYSTEM: 'Nhân viên hệ thống',
  LABOR: 'Lao công',

  CN: "Công nhân",
  MECHANICAL: "Cơ khí",
  LEADER: 'Tổ trưởng',
  MANAGER: 'Quản đốc',
};

export const TIME_KEEPING_LEAVE_TYPE = {
  ANNUAL_LEAVE: "Nghỉ phép",
  SICK_LEAVE: "Nghỉ bệnh",
  UNPAID_LEAVE: "Nghỉ ko lương",
  UNAUTHORIZED_LEAVE: "Nghỉ không phép",
  EMPTY_TASK_LEAVE: 'Nghỉ không có việc',
};

export const PN_DRIVE_RENTAL_CONTRACT_STATUS = {
  INIT: "Khởi tạo",
  FINISHED: "Hoàn thành",
};

export const PN_TRANSPORT_BILL_STATUS = {
  INIT: "Khởi tạo",
  CONFIRMED: "Đã xác nhận",
}
export const PN_TRANSPORT_STATUS = {
  ...PN_TRANSPORT_BILL_STATUS,
  DELIVERING: "Đang vận chuyển",
  FINISHED: "Hoàn thành",
};

export const STAFF_MONEY_FLOW_AGREED_TYPE = {
  AGREE: "Đã xác nhận",
  DISAGREE: "Chưa xác nhận",
};

export const USER_JOB_TITLE = {
  CEO: "Giám đốc",
  ACCOUNTANT_CHIEF: "Kế toán trưởng",
  OFFICE: "NV văn phòng",
  MECHANICAL: "NV cơ khí",
  MANAGER: "Quản đốc",
  SYSTEM: "NV hệ thống",
  CLEANING: "Lao công / phụ việc",
  WORKER: "Công nhân",
  SHIFT_LEADER: "Tổ trưởng",
};

export const SETTING_KEY = {
  ASSIGN_REVIEWER_BILL: "ASSIGN_REVIEWER_BILL",
  ASSIGN_REVIEWER_TRANSACTION_HISTORY: "ASSIGN_REVIEWER_TRANSACTION_HISTORY",
  ASSIGN_REVIEWER_PN_TRANSACTION_HISTORY: "ASSIGN_REVIEWER_PN_TRANSACTION_HISTORY",
  ASSIGN_REVIEWER_PN_CUSTOMER_MONEY_FLOW: "ASSIGN_REVIEWER_PN_CUSTOMER_MONEY_FLOW",
  ASSIGN_REVIEWER_PN_STAFF_MONEY_FLOW: "ASSIGN_REVIEWER_PN_STAFF_MONEY_FLOW",

  QUATATION_IN_INGREDIENT: "QUATATION_IN_INGREDIENT",
  TAGS: "TAGS",
  EXTRA_HOUR_FOOD_PER_SHIFT_ALLOWANCE: "EXTRA_HOUR_FOOD_PER_SHIFT_ALLOWANCE",
  FOOD_PER_SHIFT_ALLOWANCE: "FOOD_PER_SHIFT_ALLOWANCE",
  WORKING_DAY_PER_MONTH: "WORKING_DAY_PER_MONTH",
  WORKING_DAY_DRIVER_PER_MONTH: "WORKING_DAY_DRIVER_PER_MONTH",
  MIN_WORKING_DAY_TO_RECEIVED_FULL_ALLOWANCE: "MIN_WORKING_DAY_TO_RECEIVED_FULL_ALLOWANCE",
  MIN_WORKING_DAY_OF_OIL_REFINING_TO_RECEIVED_FULL_ALLOWANCE: "MIN_WORKING_DAY_OF_OIL_REFINING_TO_RECEIVED_FULL_ALLOWANCE",
  OIL_REFINING_PER_SHIFT_ALLOWANCE: "OIL_REFINING_PER_SHIFT_ALLOWANCE",

  DELIVERY_FEE_PER_CONTAINER: 'DELIVERY_FEE_PER_CONTAINER',
  SHIP_FEE_SEAL_FEE_PER_CONTAINER: 'SHIP_FEE_SEAL_FEE_PER_CONTAINER',
  CO_FEE: 'CO_FEE',
  BASE_FEE_BANK_FEE: 'BASE_FEE_BANK_FEE',
  BASE_FEE_PACKAGE_FEE: 'BASE_FEE_PACKAGE_FEE',
  BASE_FEE_SHIP_BUILDING_FEE: 'BASE_FEE_SHIP_BUILDING_FEE',
  INFARSTRUCTURE_FEE: 'INFARSTRUCTURE_FEE',
  LIFT_OFF_FEE: 'LIFT_OFF_FEE',
  SHIP_FEE_CUSTOM_FEE: 'SHIP_FEE_CUSTOM_FEE',
  INTERNAL_CUSTOMER_HANDLE_CUSTOM_FEE: 'INTERNAL_CUSTOMER_HANDLE_CUSTOM_FEE',

  ASSIGN_APPROVE_MATERIAL: "ASSIGN_APPROVE_MATERIAL",
  ASSIGN_CONFIRM_MATERIAL: "ASSIGN_CONFIRM_MATERIAL",
  ASSIGN_REVIEWER_INGREDIENT_PRICE_HISTORY: "ASSIGN_REVIEWER_INGREDIENT_PRICE_HISTORY",
  ASSIGN_REVIEWER_INVENTORY: "ASSIGN_REVIEWER_INVENTORY",
  HANDLER_EXTERNAL_CONTRACT: "HANDLER_EXTERNAL_CONTRACT",
  HANDLER_INGREDIENT_PRICE_HISTORY: "HANDLER_INGREDIENT_PRICE_HISTORY",
  THRESHOLD_LEAVE_DAY_TO_NOT_RECEIVED_ALLOWANCE: "THRESHOLD_LEAVE_DAY_TO_NOT_RECEIVED_ALLOWANCE",

  INGREDIENT_SELL_SPECIFIC_USER_IDS: "INGREDIENT_SELL_SPECIFIC_USER_IDS",
  INGREDIENT_BUY_SPECIFIC_USER_IDS: "INGREDIENT_BUY_SPECIFIC_USER_IDS",
  DEFAULT_COMMISSION_INGREDIENT_FEE_EXPORT: "DEFAULT_COMMISSION_INGREDIENT_FEE_EXPORT",
  INGREDIENT_PRICE_HISTORY_USER_CAN_DELETE: "INGREDIENT_PRICE_HISTORY_USER_CAN_DELETE",
};

export const DEFAULT_INVENTORY_OUT_OUTSIDE = {
  id: "",
  date: moment().format("YYYY-MM-DD HH:mm"),
  quantity: 0,
  truckId: 0,
  customerId: null,
  userId: "",
};



export const TYPE_BANK_ACCOUNT = {
  'PERSONAL': 'Cá nhân',
  'COMPANY': 'Công ty'
}


export const MATERIAL_INVENTORY_REQUEST_STATUS = {
  REQUESTED: 'Gửi yêu cầu',
  APPROVED: 'Đã duyệt',
  CONFIRMED: 'Đã tạo công nợ',
}

export const getDefaultEmployeeTask = () => ({
  workDate: moment().format('YYYY-MM-DD'),
  taskCategoryId: null,
  description: null,
  timeSpent: null,
});

export const TASK_CATEGORY_GROUP = {
  CHAY_MAY: 'CHẠY MÁY',
  LEN_XUONG_HANG: 'LÊN XUỐNG HÀNG',
  VE_SINH_BAO_DUONG: 'VỆ SINH BẢO DƯỠNG',
  SUA_CHUA: 'SỬA CHỮA',
  TRUC_CA: 'TRỰC CA',
  KIEM_TRA: 'KIỂM TRA',
}

export const getDefaultTaskCategory = () => ({
  name: null,
  description: null,
  group: 'CHAY_MAY',
  isActive: true,
});

export const PN_CUSTOMER_INTERNAL_ID_NAME = {
  KH_TANLOC: 'Tấn Lộc',
  KH_CUONGTHINH: 'Cường Thịnh',
}


export const encryptBill = ({
  billId,
  companyId
}) => {
  const data = JSON.stringify({
    billId,
    companyId
  })
  return Buffer.from(data, "utf8").toString("base64");
}

export const decryptBill = (encryptData) => {
  const data = Buffer.from(encryptData, "base64").toString("utf8");
  return JSON.parse(data);
}

// QR phiếu cân gia công (win-app, không chứa ghi chú): "G4" + nội dung đã làm rối.
// Nội dung gốc: công ty*kho*mã phiếu*KH*ĐVVC*nguyên liệu*I/O/S*biển số*tổng*xe*thời gian (unix giây base36)
// "%" thay cho "_" (để QR mã hoá dạng alphanumeric cho gọn), ĐVVC "1" = xe nội bộ
export const OUTSOURCING_QR_PREFIX = "G4";
const OUTSOURCING_QR_TYPE = { I: "IN", O: "OUT", S: "SERVICE" };
const OUTSOURCING_QR_INTERNAL_DELIVERY_PROVIDER_ID = "NCC_VCPHUONGNAM";
const OUTSOURCING_QR_FIELD_COUNT = 11;

// Gỡ làm rối: app cân dịch từng ký tự trong bảng 44 ký tự alphanumeric của QR theo vị trí rồi đảo ngược chuỗi.
// PHẢI giữ giống hệt scrambleQrText trong win-app-tauri/src/lib/qr.ts
const OUTSOURCING_QR_ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ$%*+-./:";
const OUTSOURCING_QR_SCRAMBLE_KEY = [17, 5, 29, 11, 38, 2, 23, 14, 33, 8, 41, 20];
const unscrambleOutsourcingQr = (text) => {
  const n = OUTSOURCING_QR_ALPHABET.length;
  return Array.from(text)
    .reverse()
    .map((ch, i) => {
      const idx = OUTSOURCING_QR_ALPHABET.indexOf(ch);
      if (idx < 0) {
        return ch;
      }
      const shift = (OUTSOURCING_QR_SCRAMBLE_KEY[i % OUTSOURCING_QR_SCRAMBLE_KEY.length] + i * 7) % n;
      return OUTSOURCING_QR_ALPHABET[(idx - shift + n) % n];
    })
    .join("");
};

export const isOutsourcingQr = (text) => typeof text === "string" && text.startsWith(OUTSOURCING_QR_PREFIX);

// Đọc QR phiếu cân gia công, null nếu không phải QR gia công
export const decodeOutsourcingQr = (text) => {
  if (!isOutsourcingQr(text)) {
    return null;
  }
  const fields = unscrambleOutsourcingQr(text.slice(OUTSOURCING_QR_PREFIX.length))
    .split("*")
    .map((e) => e.replace(/%/g, "_"));
  if (fields.length !== OUTSOURCING_QR_FIELD_COUNT || !OUTSOURCING_QR_TYPE[fields[6]]) {
    return null;
  }
  const [companyId, warehouseId, ticketId, customerId, deliveryProvider, ingredientId, typeCode, truckId, total, truck, at] = fields;
  const type = OUTSOURCING_QR_TYPE[typeCode] || "IN";
  const side = type === "OUT" ? "departure" : "destination";
  const weightAt = at ? new Date(parseInt(at, 36) * 1000).toISOString() : null;
  return {
    billId: `${warehouseId}${ticketId}`,
    companyId: companyId || null,
    customerId,
    warehouseId,
    deliveryProviderId: deliveryProvider === "1" ? OUTSOURCING_QR_INTERNAL_DELIVERY_PROVIDER_ID : deliveryProvider || null,
    ingredientId,
    type,
    truckId,
    [`${side}TotalWeight`]: Number(total) || 0,
    [`${side}TruckWeight`]: Number(truck) || 0,
    [`${side}MerchandiseWeight`]: Math.abs((Number(total) || 0) - (Number(truck) || 0)),
    [`${side}TotalWeightAt`]: weightAt,
    [`${side}TruckWeightAt`]: weightAt,
    isOutsourcingBill: true,
  };
};

// QR phiếu cân gia công quét ở màn "Quét mã QR" thường: đổi về dạng QR phiếu thường
// base64(JSON {billId, companyId}) để mở cập nhật đơn như phiếu cân thường. null nếu không đọc được.
export const outsourcingQrToBillScanData = (text) => {
  const qr = decodeOutsourcingQr(text);
  if (!qr?.billId || !qr?.companyId) {
    return null;
  }
  return btoa(JSON.stringify({ billId: qr.billId, companyId: qr.companyId }));
};

export const EXTERNAL_PORT_FEE_CATEGORY_ID = {
  PHI_NANG: 'PHI_NANG',
  PHI_HA: 'PHI_HA',
  BOI_DUONG_NANG_HA: 'BOI_DUONG_NANG_HA',
  CSHT: 'CSHT'
}

export const INGREDIENT_CATEGORY_ID = {
  CHD: 'CHD',
  VNB: 'VNB',
  DL: 'DL',
  CUI: 'CUI',
  DDT: 'DDT',
  DTP: 'DTP',
  VHD: 'VHD',
  BHD: 'BHD',
  VNG: 'VNG',
  DCDN2: 'DCDN2'

}

export const INGREDIENT_CATEGORY_NAME = {
  [INGREDIENT_CATEGORY_ID.CHD]: 'Bã nhuyễn',
  [INGREDIENT_CATEGORY_ID.VNB]: 'Viên nén bã',
  [INGREDIENT_CATEGORY_ID.DL]: 'Dầu lắng',
  [INGREDIENT_CATEGORY_ID.CUI]: 'Củi',
  [INGREDIENT_CATEGORY_ID.DDT]: 'Dầu điều thô',
  [INGREDIENT_CATEGORY_ID.DTP]: 'Dầu tinh phẩm',
  [INGREDIENT_CATEGORY_ID.VHD]: 'Vỏ hạt điều',
  [INGREDIENT_CATEGORY_ID.BHD]: 'Bã hạt điều',
  [INGREDIENT_CATEGORY_ID.VNG]: 'Viên nén gỗ',
  [INGREDIENT_CATEGORY_ID.DCDN2]: 'Dầu Cardanol loại 2',
}

export const INGREDIENT_OTHER_NOT_NEED_REQUEST = {
  DVVC: 'DVVC',
  HH_BH: 'HH_BH',
  'HH-MH': 'HH-MH',
  VAT: 'VAT',
  // Phí thuê gia công (đơn con GC-{mã đơn}), khớp với BE
  GC: 'GC',
}



export const getDefaultPnBill = () => ({
  createdAt: moment().format(`${formatDateYMD} HH:mm`),
  status: 'INIT',
  driverId: null,
  subDriverId: null,
  driverBonus: 0,
  subDriverBonus: 0,
  deliveryFeeByWeight: 0,
  deliveryFeeExternal: 0,
  location: 'INTERNAL',
  finalMerchandiseWeight: 1,
  seaportId: null,
})

export const randomString = (len, seeds = null) => {
  let text = '';
  const newSeeds = seeds || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < len; i += 1) {
    text += newSeeds.charAt(Math.floor(Math.random() * newSeeds.length));
  }

  return text;
};

export const INGREDIENT_GROUP = {
  EXTERNAL_PORT_FEE: 'EXTERNAL_PORT_FEE',
  OTHER: 'OTHER',
  INGREDIENT: 'INGREDIENT',
  STAFF: 'STAFF',
  STAFF_OUT: 'STAFF_OUT',
}

export const INGREDIENT_GROUP_NAME = {
  [INGREDIENT_GROUP.EXTERNAL_PORT_FEE]: 'Phí cảng bãi',
  [INGREDIENT_GROUP.OTHER]: 'Khác',
  [INGREDIENT_GROUP.INGREDIENT]: 'Nguyên liệu',
  [INGREDIENT_GROUP.STAFF]: 'Nhân viên chi',
  [INGREDIENT_GROUP.STAFF_OUT]: 'Nhân viên nợ',

}
export const PN_OTHER_CATEGORY_FOR_TRUCK = [
  'SC_XE',
  'EPASSS',
  'PHI_HA_NCC_KH',
]

export const PN_STATIC_CATEGORY_SALARY_FOR_DRIVER = {
  ADVANCE_SALARY: 'ADVANCE_SALARY',
  INSURANCE_FEE: 'INSURANCE_FEE',
  PIT_FEE: 'PIT_FEE',
  UNION_FEE: 'UNION_FEE',
}

export const PN_STATIC_CATEGORY_SALARY_FOR_DRIVER_NAME = {
  [PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.ADVANCE_SALARY]: 'Ứng trước',
  [PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.INSURANCE_FEE]: 'BHXH',
  [PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.PIT_FEE]: 'Thuế TNCN',
  [PN_STATIC_CATEGORY_SALARY_FOR_DRIVER.UNION_FEE]: 'Phí công đoàn',
}

export const COMPANY_FULL_INFO = {
  TL: {
    name: 'CÔNG TY TNHH SẢN XUẤT DẦU ĐIỀU TẤN LỘC',
    company: 'TL',
    taxCode: '3603424660',
    phone: '0984 858 255',
    address: 'Số 88A, Tổ 10, KP Tân Cang, P. Phước Tân, T. Đồng Nai'
  },
  CT: {
    name: 'CÔNG TY TNHH SẢN XUẤT DẦU ĐIỀU CƯỜNG THỊNH',
    company: 'CT',
    taxCode: '3801238680',
    phone: '0933 504 455',
    address: 'Đội 4, ấp Đồng Tiến 3, Xã Đồng Tâm, Đồng Nai'
  },
  PN: {
    name: 'CÔNG TY TNHH CƠ KHÍ VẬN TẢI PHƯƠNG NAM',
    company: 'PN',
    taxCode: '3603855201',
    phone: '0933 504 455',
    address: 'Số 100/2, Ấp Lộc Hòa, Xã Hưng Thịnh, Đồng Nai'
  }
}[process.env.REACT_APP_COMPANY];

export const INGREDIENT_PRICE_HISTORY_TARGET_BY = {
  WEIGHT: 'WEIGHT',
  TRUCK: 'TRUCK',
}

export const INGREDIENT_PRICE_HISTORY_TARGET_BY_NAME = {
  [INGREDIENT_PRICE_HISTORY_TARGET_BY.WEIGHT]: 'Khối lượng',
  [INGREDIENT_PRICE_HISTORY_TARGET_BY.TRUCK]: 'Xe',
}

export const REPORT_ASSIGN_CONFIRM_TYPE = {
  APPROVED: 'APPROVED',
  NOT_APPROVED: 'NOT_APPROVED',
  NOT_APPROVED_BY_ME: 'NOT_APPROVED_BY_ME',
}

export const REPORT_ASSIGN_CONFIRM_TYPE_OPTIONS = [
  {
    label: 'Đã duyệt',
    value: REPORT_ASSIGN_CONFIRM_TYPE.APPROVED,
  },
  {
    label: 'Chưa duyệt',
    value: REPORT_ASSIGN_CONFIRM_TYPE.NOT_APPROVED,
  },
  {
    label: 'Chưa duyệt bởi tôi',
    value: REPORT_ASSIGN_CONFIRM_TYPE.NOT_APPROVED_BY_ME,
  }
]

export const INGREDIENT_PRICE_HISTORY_COMMISSION_TYPE = {
  SALE: 'Sale',
  BONUS_FUND: 'Quỹ Chung',
}

export const CURRENCY_CODE = {
  VND: 'VND',
  USD: 'USD',
}

export const CURRENCY_CODE_NAME = {
  [CURRENCY_CODE.VND]: 'Việt Nam Đồng',
  [CURRENCY_CODE.USD]: 'Đô La Mỹ',
}

export const CURRENCY_CODE_OPTIONS = Object.values(CURRENCY_CODE).map((c) => ({
  label: CURRENCY_CODE_NAME[c],
  value: c,
}));